export default __webpack_public_path__ + "static/media/news36.7b01300a.jpg";